import * as React from 'react';
import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, Step, Stepper, StepLabel } from '@mui/material';
import { toast } from 'react-toastify';
import { PasoUno } from './StepOne';
import { PasoDos } from './StepTwo';
import { ReactHookForm } from './form-validation-view/react-hook-form';

const steps = ['Datos de campaña', 'Seleccion de contenido', 'Enviar campaña'];

// Mock data for campaigns
const mockCampaigns = [
  {
    id: 1,
    nombre: 'Campaña de Bienvenida',
    canal: 1,
    filtros: [],
    contenidos: []
  }
];

export const NewCampaigns = () => {
  const [value, setValue] = useState('');
  const [filter, setFilter] = useState([]);
  const [errors, setErrors] = useState({});
  const location = useLocation();
  const [activeStep, setActiveStep] = useState(location.state?.activeStep ?? 0);
  const [dataSend, setDataSend] = useState({ nombre: '', canal: 1, filtros: [] });
  const navigate = useNavigate();

  // Actualizar activeStep cuando cambia el estado de navegación
  useEffect(() => {
    if (location.state?.activeStep !== undefined) {
      setActiveStep(location.state.activeStep);
    }
  }, [location.state]);

  const validate = () => {
    const newErrors = {};
  
    if (!value.trim()) {
      newErrors.value = 'El nombre de la campaña es obligatorio.';
    }
  
    // Los filtros ya no son obligatorios, pero validamos que si existen, estén completos
    if (filter.length > 0) {
      filter.forEach((f, index) => {
        if (!f.type) {
          newErrors.filter = `Debe seleccionar al menos un tipo de filtro.`;
        } else if (!f.values || f.values.length === 0) {
          newErrors.filter = `Debe seleccionar mínimo una opción.`;
        }
      });
    }
  
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const setValuesContent = (data) => {
    const dataToSent = { ...dataSend };
    dataToSent.contenidos = [data];
    
    // Mock API call
    setTimeout(() => {
      const newCampaign = {
        ...dataToSent,
        id: mockCampaigns.length + 1
      };
      mockCampaigns.push(newCampaign);
      
      toast.success('Campaña creada exitosamente');
      navigate(`/dashboard/campaigns/view`, { state: { idCampana: newCampaign.id } });
    }, 1000);
  };

  const handleNext = (text, filters, excelFile = null, audienceSource = 'all', sendType = 'after_approval', sendDate = '', sendTime = '', proyectoId = '', asesorId = '') => {
    const transformedFilters = filters.map((f) => ({
      tipo: f.type,
      valores: f.values || [],
    }));

    setDataSend((prevState) => ({
      ...prevState,
      nombre: text,
      filtros: transformedFilters,
    }));

    // Guardar datos del paso 1 en sessionStorage para uso posterior
    const stepOneData = {
      nombre_campaign: text,
      filtros: transformedFilters,
      upload_audiencia: audienceSource === 'excel',
      sendType: sendType,
      sendDate: sendDate,
      sendTime: sendTime,
      proyectoId: audienceSource === 'excel' ? '' : proyectoId,
      asesorId: audienceSource === 'excel' ? '' : asesorId,
    };
    sessionStorage.setItem('campaign_step1_data', JSON.stringify(stepOneData));
    
    // Guardar el archivo Excel como base64 si existe
    if (excelFile) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result.split(',')[1]; // Remover el prefijo data:application/...
        sessionStorage.setItem('campaign_excel_file', base64String);
        sessionStorage.setItem('campaign_excel_file_name', excelFile.name);
        sessionStorage.setItem('campaign_excel_file_type', excelFile.type);
      };
      reader.onerror = () => {
        console.error('Error al leer el archivo Excel');
      };
      reader.readAsDataURL(excelFile);
    } else {
      // Limpiar archivo Excel si no existe
      sessionStorage.removeItem('campaign_excel_file');
      sessionStorage.removeItem('campaign_excel_file_name');
      sessionStorage.removeItem('campaign_excel_file_type');
    }

    // Limpiar error de filtros si no hay filtros (es opcional)
    if (filters.length === 0) {
      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors.filter;
        return newErrors;
      });
    }

    if (validate()) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };

  const handleNext2 = (text, filters) => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const stepContent = [
    <PasoUno 
      key='step1' 
      value={value} 
      setValue={setValue} 
      filter={filter} 
      setFilter={setFilter} 
      errors={errors} 
      setErrors={setErrors} 
      handleNext={handleNext} 
    />,
    <PasoDos 
      key='step2' 
      handleBack={handleBack} 
      handleNext={handleNext2} 
    />
  ];

  return (
    <Box sx={{ display: 'flex', flex: '1 1 auto', backgroundColor: '#FFFFFF', flexDirection: 'column', p: 3 }}>
      <Box sx={{ width: '100%', maxWidth: '1900px' }}>
        <Stepper
          activeStep={activeStep}
          sx={{
            mb: 3,
            '& .MuiStepIcon-root.Mui-active': {
              color: '#2fa14e',
            },
            '& .MuiStepIcon-root.Mui-completed': {
              color: '#2fa14e',
            },
            '& .MuiStepLabel-label.Mui-active': {
              color: '#2fa14e',
              fontWeight: 'bold',
            },
            '& .MuiStepLabel-label.Mui-completed': {
              color: '#2fa14e',
              fontWeight: 'bold',
            },
          }}
        >
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
        {activeStep !== 2 && <>{stepContent[activeStep]}</>}
        {activeStep === 2 && <ReactHookForm key='step3' handleBack={handleBack} setValues={setValuesContent} />}
      </Box>
    </Box>
  );
}; 
